/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Allroles2Inputs */

const zh_organizationsettings_allroles2 = /** @type {(inputs: Organizationsettings_Allroles2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有角色`)
};

const en_organizationsettings_allroles2 = /** @type {(inputs: Organizationsettings_Allroles2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Roles`)
};

const es_organizationsettings_allroles2 = /** @type {(inputs: Organizationsettings_Allroles2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los roles`)
};

/**
* | output |
* | --- |
* | "All Roles" |
*
* @param {Organizationsettings_Allroles2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_allroles2 = /** @type {((inputs?: Organizationsettings_Allroles2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Allroles2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_allroles2(inputs)
	if (locale === "en") return en_organizationsettings_allroles2(inputs)
	return es_organizationsettings_allroles2(inputs)
});
export { organizationsettings_allroles2 as "organizationSettings_allRoles" }